<h2 mat-dialog-title>
  {{ "observationcard.detail.title" | translate }}:
  {{ data.element.cardNumber }} -
  {{ data.element.status.description | translate }}
</h2>

<mat-dialog-content class="mat-typography">
  <table class="user-table">
    <tr>
      <td class="label">
        <strong>{{ "observationcard.detail.firstname" | translate }}:</strong>
      </td>
      <td>{{ data.element.firstName }}</td>
      <td class="label">
        <strong>{{ "observationcard.detail.lastname" | translate }}:</strong>
      </td>
      <td>{{ data.element.lastName }}</td>
    </tr>
    <tr>
      <td class="label">
        <strong>{{ "observationcard.detail.datetime" | translate }}:</strong>
      </td>
      <td>{{ data.element.insertDate | date : "dd/MM/yyyy HH:mm" }}</td>
      <td class="label">
        <strong>{{ "observationcard.detail.role" | translate }}:</strong>
      </td>
      <td>{{ data.element.role }}</td>
    </tr>
    <tr>
      <td class="label">
        <strong>{{ "observationcard.detail.type" | translate }}:</strong>
      </td>
      <td>{{ data.element.activityType.description }}</td>
      <td class="label">
        <strong>{{ "observationcard.detail.location" | translate }}:</strong>
      </td>
      <td>{{ data.element.location }}</td>
    </tr>
    <tr>
      <td class="label">
        <strong>{{ "observationcard.detail.company" | translate }}:</strong>
      </td>
      <td>{{ data.element.company }}</td>
      <td class="label">
        <strong>{{ "observationcard.detail.project" | translate }}:</strong>
      </td>
      <td>{{ data.element.project.description }}</td>
    </tr>
    <tr>
      <td class="label">
        <strong>{{ "observationcard.detail.activity" | translate }}:</strong>
      </td>
      <td>{{ data.element.activity }}</td>
      <td class="label">
        <strong>{{ "observationcard.form.origin" | translate }}:</strong>
      </td>
      <td *ngIf="data.element.origin === 'APP_MOBILE'">
        <mat-icon>phone_android</mat-icon>
      </td>
      <td *ngIf="data.element.origin === 'QR_CODE'">
        <mat-icon>qr_code_2</mat-icon>
      </td>
      <td *ngIf="data.element.origin === 'WEB_APP'">
        <mat-icon>language</mat-icon>
      </td>
    </tr>
    <tr>
      <td class="label">
        <strong>{{ "observationcard.detail.observation" | translate }}:</strong>
      </td>
      <td>{{ data.element.observation }}</td>
      <td class="label">
        <strong>{{ "observationcard.detail.action" | translate }}:</strong>
      </td>
      <td>{{ data.element.action }}</td>
    </tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="buttonClicked('ok')">Ok</button>
</mat-dialog-actions>
